export function LastUsedBadge() {
  return (
    <span className="absolute -right-2 -top-2 rounded-listen-4 border border-surface-quatenary bg-surface-highlight px-1.5 py-1 text-[10px] leading-none text-blue-500 shadow-sm">
      Last used
    </span>
  );
}
